import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

const DndProvider = ({ children, id, onDragEnd }) => (
  <DragDropContext onDragEnd={onDragEnd}>
    <Droppable droppableId={id}>
      {(droppableProvided) => (
        <div
          ref={droppableProvided.innerRef}
        >
          {children}
          {droppableProvided.placeholder}
        </div>
      )}
    </Droppable>
  </DragDropContext>
);

DndProvider.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  onDragEnd: PropTypes.func,
};

DndProvider.defaultProps = {
  onDragEnd: () => {},
};

export default DndProvider;
